import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import * as Constants from "Data/Constants";
import { Button } from "GameObjects/Button";

export class LandingPage extends HLF.State {
	protected _next: string;
    private readonly _bg: PIXI.Sprite;
    private readonly _playBtn: Button;

	public constructor(pData: {next: string}) {
		super();
		this._next = pData.next;

        this._bg = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._bg.anchor.set(0.5);
        this._bg.interactive = true;
        this._bg.once(HLF.Input.Events.POINTER_TAP, this.onPlayBtnPressed.bind(this));
        this.addChild(this._bg);

        const startText = HLF.PixiUtils.makeText(`Landing Page`, Constants.FONT_GEL_MED_35, 35, 0x555555);
        this.addChild(startText);

        this._playBtn = new Button(this.onPlayBtnPressed.bind(this), "button-play", Constants.SPRITESHEET_UI);
        this._playBtn.alpha = 0;
        this._playBtn.interactive = false;
        this._playBtn.position.set(0, 180);
        this.addChild(this._playBtn);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this._bg.width = pSize.x;
        this._bg.height = pSize.y;
    }

    public animateIn(pOnComplete: () => void): void {
        pOnComplete();
        this._playBtn.interactive = true;

        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this._playBtn, 0.5, {
            alpha: 1,
        });
        timeline.call(() => {
            PubSub.publishSync(HLF.REGISTER_FOCUSABLE, this._playBtn);
        });
    }

    public animateOut(pOnComplete: () => void): void {
        this._playBtn.interactive = false;
        this._bg.interactive = false;
        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this, 0.5, {
            alpha: 0,
        });
        timeline.call(pOnComplete);
    }

    private onPlayBtnPressed(): void {
        PubSub.publishSync(HLF.UNREGISTER_FOCUSABLE, this._playBtn);

        PubSub.publishSync(HLF.STATE_LOAD_STATE, new HLF.StateToken(
			{id: this._next, data: {
				name: this._next,
			}}, undefined, ...HLF.StateToken.TRANSITION_ANIM_OLD_OUT_REVEAL)
        );
    }
}
